@if(amountDetails) {
  <div class="payment-summary sm:my-10 my-16 flex sm:px-[30%] px-[5%] flex-col gap-4">
    <h3 class="text-center dsr-typescale-title-small" >{{ "OFFER_PAYMENT_POPUP_LABEL" | translate }}</h3>
    <div class="summary-row border-t border-light-dsr-color-outline-variant pt-4 flex items-center justify-between ">
      <div class="label">{{ (amountDetails.title || amountDetails.type || "Item") | translate }}</div>
      <div class="value">
        <span class="dsr-typescale-body-small-prominent">{{ amountDetails.priceTTC || amountDetails.price || "0" }} &euro;</span>
        ({{ 'TTC_LABEL' | translate }})
      </div>
    </div>
  </div>
}
